import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2Icon, GiftIcon } from 'lucide-react';
export function WhatYouGet() {
  const items = [{
    title: 'Guía Paso a Paso',
    description: 'El protocolo exacto para desinflamar día por día, sin dejar nada al azar.'
  }, {
    title: 'Menú Flexible de 7 Días',
    description: 'Con 3 opciones por comida para que no te aburras y comas lo que te gusta.'
  }, {
    title: 'Lista de Compras AR',
    description: 'Qué traer (y qué dejar) en el supermercado local. Cuidamos tu bolsillo.'
  }, {
    title: 'Protocolo de Rescate 24h',
    description: "Qué hacer cuando te sentís 'explotada' y necesitás alivio ya mismo."
  }, {
    title: 'Checklist de Villanos del Súper',
    description: 'Aprendé a leer etiquetas en 3 segundos para que no te engañen más.'
  }];
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      x: -20
    },
    visible: {
      opacity: 1,
      x: 0,
      transition: {
        duration: 0.5
      }
    }
  };
  return <section className="py-20 px-4 bg-cream" data-id="element-150">
      <div className="max-w-4xl mx-auto" data-id="element-151">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-152">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-153">
            ¿Qué incluye el plan?
          </h2>
          <p className="text-lg text-brown/70" data-id="element-154">
            Todo lo que necesitás, directo al grano y sin relleno.
          </p>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="grid gap-6" data-id="element-155">
          {items.map((item, index) => <motion.div key={index} variants={itemVariants} className="flex items-start gap-4 bg-white p-6 rounded-2xl shadow-sm border border-sage/10" data-id="element-156">
              <CheckCircle2Icon className="w-6 h-6 text-sage flex-shrink-0 mt-1" data-id="element-157" />
              <div data-id="element-158">
                <h3 className="text-xl font-bold mb-2" data-id="element-159">{item.title}</h3>
                <p className="text-brown/80" data-id="element-160">{item.description}</p>
              </div>
            </motion.div>)}

          {/* Bonus Item */}
          <motion.div variants={itemVariants} className="flex items-start gap-4 bg-gradient-to-br from-gold/20 to-gold/5 p-6 rounded-2xl shadow-sm border border-gold/30 mt-4 relative overflow-hidden" data-id="element-161">
            <div className="absolute top-0 right-0 bg-gold text-white text-xs font-bold px-3 py-1 rounded-bl-lg" data-id="element-162">
              BONUS EXCLUSIVO
            </div>
            <GiftIcon className="w-6 h-6 text-gold flex-shrink-0 mt-1" data-id="element-163" />
            <div data-id="element-164">
              <h3 className="text-xl font-bold mb-2 text-brown" data-id="element-165">
                Guía de Supervivencia Social
              </h3>
              <p className="text-brown/80" data-id="element-166">
                Cómo sobrevivir al asado del domingo, la juntada con amigas o el
                cumple familiar sin terminar hinchada ni privarte de disfrutar.
              </p>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}